import { getDaysInMonth, set } from 'date-fns';

export const getEndDecadeDay = (day, date) => {
  if (day <= 10) return 10;
  if (day <= 20) return 20;
  return getDaysInMonth(date);
};
export const getStartDecadeDay = (day) => {
  if (day > 20) return 21;
  if (day > 10) return 11;
  return 1;
};

export const getHowManyDecade = (day, howDate) => {
  if (howDate === 'start') {
    if (day <= 10) return 0;
    if (day <= 20) return 1;
    return 2;
  }
  if (day > 20) return 0;
  if (day > 10) return 1;
  return 2;
};

export function compareDates(start, end) {
  if (new Date(start) > new Date(end)) {
    console.log('%c Error dates', 'color: red', start, end);
    return false;
  }
  return true;
}

export function weekDays({ count, pageArg, date }) {
  if (count === pageArg) {
    // конечная дата
    const resultEnd = new Date(date.endDate);
    // ДЕНЬ НЕДЕЛИ конечной даты
    const endDay = new Date(resultEnd).getDay();
    // понедельник
    const monday = new Date(resultEnd).setDate(new Date(resultEnd).getDate() - (endDay === 0 ? 7 : endDay) + 1);
    const resultStart = count === 0 ? new Date(date.startDate) : set(new Date(monday), { hours: 0, minutes: 0, seconds: 0 });
    return { start: resultStart, end: resultEnd };
  }
  // последняя страница
  if (pageArg === 0) {
    // берем начальную дату
    const startDate = new Date(date.startDate);
    const sunday = new Date(new Date(startDate).setDate(startDate.getDay() === 0 ? startDate.getDate() : (startDate.getDate() + 7 - startDate.getDay())));
    return { start: startDate, end: set(new Date(sunday), { hours: 23, minutes: 59, seconds: 0 }) };
  }

  // промежутки

  // вычисляем текущую неделю на странице
  const weeksAgo = new Date(date.endDate).getDate() - 7 * (count - pageArg);
  // день текущей недели
  const dayInCurrentWeek = new Date(new Date(date.endDate).setDate(weeksAgo));
  // понедельник
  const monday = new Date(dayInCurrentWeek).setDate(new Date(dayInCurrentWeek).getDate() - (new Date(dayInCurrentWeek).getDay() === 0 ? 7 : new Date(dayInCurrentWeek).getDay()) + 1);
  // воскресенье
  const sunday = new Date(monday).setDate(new Date(monday).getDate() + 6);
  return { start: set(new Date(monday), { hours: 0, minutes: 0, seconds: 0 }), end: set(new Date(sunday), { hours: 23, minutes: 59, seconds: 0 }) };
}

export function monthDays({ count, pageArg, date }) {
  // первая страница
  if (count === pageArg) {
    const dateEnd = new Date(date.endDate);
    let dateStart = new Date(date.startDate);
    if (count === 0) {
      return { start: dateStart, end: dateEnd };
    }
    dateStart = set(new Date(dateEnd), { month: dateEnd.getMonth(), date: 1 });
    return { start: set(dateStart, { hours: 0, minutes: 0 }), end: dateEnd };
  }
  // последняя страница
  if (pageArg === 0) {
    const dateStart = new Date(date.startDate);
    const dateEnd = set(new Date(dateStart), { date: getDaysInMonth(dateStart) });
    return { start: dateStart, end: set(dateEnd, { hours: 23, minutes: 59 }) };
  }
  // остальные страницы
  const newDateEnd = new Date(date.endDate); // конечная дата в new Date
  // newDateEnd.getMonth() - (count - pageArg) --- страницы идут в порядке возрастания, поэтому пришлось переделывать в порядок убывания
  const dateStart = set(new Date(newDateEnd), {
    month: newDateEnd.getMonth() - (count - pageArg), date: 1, hours: 0, minutes: 0,
  });
  const dateEnd = set(new Date(dateStart), { hours: 23, minutes: 59, date: getDaysInMonth(dateStart) });
  return { start: dateStart, end: dateEnd };
}

export function yearDays({ count, pageArg, date }) {
  if (count === pageArg) {
    const resultStart = count === 0 ? new Date(date.startDate) : new Date(new Date(date.endDate).getFullYear(), 0, 1);
    return {
      start: resultStart,
      end: new Date(date.endDate),
    };
  }
  if (pageArg === 0) {
    return {
      start: new Date(date.startDate),
      end: new Date(new Date(date.startDate).getFullYear(), 11, 31, 23, 59),
    };
  }
  const resultStart = new Date(new Date(date.endDate).getFullYear() - (count - pageArg), 0, 1, 0, 0);
  const resultEnd = new Date(new Date(date.endDate).getFullYear() - (count - pageArg), 11, 31, 23, 59);

  return {
    start: resultStart,
    end: resultEnd,
  };
}

export function dayDays({ count, pageArg, date }) {
  const start = new Date(date.startDate).setDate(new Date(date.startDate).getDate() + pageArg);
  const curStart = new Date(date.startDate).setDate(new Date(date.startDate).getDate() + pageArg);
  if (count === pageArg) {
    const resultStart = count === 0 ? new Date(curStart) : set(new Date(curStart), { hours: 0, minutes: 0 });
    return { start: resultStart, end: new Date(date.endDate) };
  }
  if (pageArg === 0) {
    return { start: curStart, end: set(new Date(start), { hours: 23, minutes: 59 }) };
  }
  const dateStart = set(new Date(curStart), { hours: 0, minutes: 0 });
  const dateEnd = set(new Date(start), { hours: 23, minutes: 59 });
  return { start: dateStart, end: dateEnd };
}

export function decadeDays({
  count, pageArg, date, decadesList,
}) {
  // первая страница
  if (count === pageArg) {
    let dateStart = new Date(date.startDate);
    const dateEnd = new Date(date.endDate);
    if (count === 0) {
      return { start: dateStart, end: dateEnd };
    }
    dateStart = set(new Date(dateEnd), { month: dateEnd.getMonth(), date: getStartDecadeDay(dateEnd.getDate()) });
    return { start: set(dateStart, { hours: 0, minutes: 0 }), end: dateEnd };
  }
  // последняя страница
  if (pageArg === 0) {
    const dateStart = new Date(date.startDate);
    const dateEnd = set(new Date(dateStart), { date: getEndDecadeDay(dateStart.getDate(), dateStart) });

    return { start: dateStart, end: set(new Date(dateEnd), { hours: 23, minutes: 59, seconds: 0 }) };
  }
  // остальные страницы
  const currentDate = decadesList[count - pageArg];

  return {
    start: currentDate ?? new Date(),
    end: currentDate ? set(currentDate, { date: getEndDecadeDay(currentDate.getDate(), currentDate), hours: 23, minutes: 59 }) : new Date(),
  };
}

export function countDecades(count, date) {
  const end = new Date(date.endDate);
  let currentDate = set(end, { date: getStartDecadeDay(end.getDate()) });
  const decades = [currentDate];
  for (let i = 1; i <= count; i += 1) {
    currentDate = set(currentDate, {
      date: currentDate.getDate() - 1,
    });

    currentDate = set(currentDate, { date: getStartDecadeDay(currentDate.getDate()), hours: 0, minutes: 0 });
    decades.push(currentDate);
  }
  return { decades };
}

export function getCountDay(date) {
  const days = Math.floor((new Date(date.endDate).getTime() - new Date(date.startDate).getTime()) / (1000 * 60 * 60 * 24));
  return days;
}
export function getCountWeek(date) {
  const endDate = new Date(date.endDate).getDate();
  const endDay = new Date(date.endDate).getDay();

  const startDate = new Date(date.startDate).getDate();
  const startDay = new Date(date.startDate).getDay();

  const sunday = new Date(new Date(date.endDate).setDate(endDay === 0 ? endDate : (endDate + 7 - endDay)));
  const monday = new Date(date.startDate).setDate(startDate - (startDay === 0 ? 7 : startDay) + 1);

  const weeks = Math.round((sunday - monday) / (7 * 24 * 60 * 60 * 1000) - 1);
  return weeks;
}

export function getCountMonth(date) {
  const startMonth = new Date(date.startDate);
  const endMonth = new Date(date.endDate);
  // setCount(endMonth - startMonth);

  const result = endMonth.getMonth() - startMonth.getMonth()
    + (12 * (endMonth.getFullYear() - startMonth.getFullYear()));
  return result;
}

export function getCountYear(date) {
  const years = new Date(date.endDate).getFullYear() - new Date(date.startDate).getFullYear();
  return years;
}

export function getCountDecades(date) {
  const start = new Date(date.startDate);
  const end = new Date(date.endDate);
  let res = 0;
  const howStartDecade = getHowManyDecade(start.getDate(), 'start');
  const howEndDecade = getHowManyDecade(end.getDate());
  const result = end.getMonth() - start.getMonth()
    + (12 * (end.getFullYear() - start.getFullYear()));

  if (result === 0) {
    res = 3 - howStartDecade - howEndDecade - 1;
    return res;
  }
    res = (result + 1) * 3 - howStartDecade - howEndDecade - 1;
    return res;
}
